export function parsePlace(place) {
  if (!place) return { state: '', area: '' };
  if (typeof place === 'object') {
    return {
      state: place.state || '',
      area: place.location || place.area || ''
    };
  }
  try {
    const parsed = JSON.parse(place);
    return {
      state: parsed.state || '',
      area: parsed.location || parsed.area || ''
    };
  } catch (error) {
    return { state: String(place), area: '' };
  }
}

export function excerpt(text, length = 140) {
  if (!text) return '';
  const clean = String(text).replace(/\s+/g, ' ').trim();
  return clean.length > length ? `${clean.slice(0, length)}…` : clean;
}
